import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import SpecializedCareIntro from "./sections/SpecializedCareIntro";
import FeaturedTechnologyCBrace from "./sections/FeaturedTechnologyCBrace";
import OurSolutions from "./sections/OurSolutions";
import PatientsAndProvidersSupport from "./sections/PatientsAndProvidersSupport";
import OurMission from "./sections/OurMission";
import ContactForm from "./sections/ContactForm";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <SpecializedCareIntro />
      <FeaturedTechnologyCBrace />
      <OurSolutions />
      <PatientsAndProvidersSupport />
      <OurMission />
      <ContactForm />
      <Footer />
    </div>;
}